import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'shared/i18n'
import DocumentLayout from 'shared/ui/DocumentLayout'

const BracketListItem = styled('div')({
  '& ol': {
    listStyleType: 'none',
    counterReset: 'item'
  },
  '& ol li:before': {
    counterIncrement: 'item',
    content: '\'( \' counter(item) \' ) \'',
    marginLeft: '-1.5em'
  }
})

export default function ViewTermsOfUse (): JSX.Element {
  const { t } = useTranslation()
  return (
    <DocumentLayout title={t('termsOfUse.view.title2')}>
      <Typography variant="h3">{t('termsOfUse.view.text47')}</Typography>
      <Typography variant="h4">{t('termsOfUse.view.text48')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li')}
          </li>
          <li>
            {t('termsOfUse.view.li2')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text49')}</Typography>
      <Typography component="div">
        {t('termsOfUse.view.text50')}
        <ol>
          <li>
            {t('termsOfUse.view.li3')}
          </li>
          <li>
            {t('termsOfUse.view.li4')}
          </li>
          <li>{t('termsOfUse.view.li5')}</li>
          <li>{t('termsOfUse.view.li6')}</li>
          <li>{t('termsOfUse.view.li7')}</li>
          <li>{t('termsOfUse.view.li8')}</li>
          <li>
            {t('termsOfUse.view.li9')}
          </li>
          <li>
            {t('termsOfUse.view.li10')}
          </li>
          <li>
            {t('termsOfUse.view.li11')}
          </li>
          <li>
            {t('termsOfUse.view.li12')}
          </li>
          <li>
            {t('termsOfUse.view.li13')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text51')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li14')}
          </li>
          <li>
            {t('termsOfUse.view.li15')}
          </li>
          <li>
            {t('termsOfUse.view.li16')}
            <BracketListItem>
              <ol>
                <li>{t('termsOfUse.view.li17')}</li>
                <li>{t('termsOfUse.view.li18')}</li>
                <li>{t('termsOfUse.view.li19')}</li>
                <li>
                  {t('termsOfUse.view.li20')}
                </li>
                <li>{t('termsOfUse.view.li21')}</li>
                <li>{t('termsOfUse.view.li22')}</li>
              </ol>
            </BracketListItem>
          </li>
          <li>
            {t('termsOfUse.view.li23')}
          </li>
          <li>
            {t('termsOfUse.view.li24')}
          </li>
          <li>
            {t('termsOfUse.view.li25')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text52')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li26')}
          </li>
          <li>
            {t('termsOfUse.view.li27')}
          </li>
          <li>
            {t('termsOfUse.view.li28')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text53')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li29')}
          </li>
          <li>
            {t('termsOfUse.view.li30')}
          </li>
          <li>
            {t('termsOfUse.view.li31')}
          </li>
          <li>
            {t('termsOfUse.view.li32')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text54')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li33')}
            <BracketListItem>
              <ol>
                <li>
                  {t('termsOfUse.view.li34')}
                </li>
                <li>
                  {t('termsOfUse.view.li35')}
                </li>
                <li>
                  {t('termsOfUse.view.li36')}
                </li>
                <li>{t('termsOfUse.view.li37')}</li>
                <li>{t('termsOfUse.view.li38')}</li>
                <li>{t('termsOfUse.view.li39')}</li>
                <li>{t('termsOfUse.view.li40')}</li>
                <li>{t('termsOfUse.view.li41')}</li>
                <li>{t('termsOfUse.view.li42')}</li>
                <li>{t('termsOfUse.view.li43')}</li>
                <li>{t('termsOfUse.view.li44')}</li>
                <li>
                  {t('termsOfUse.view.li45')}
                </li>
                <li>
                  {t('termsOfUse.view.li46')}
                </li>
                <li>{t('termsOfUse.view.li47')}</li>
                <li>
                  {t('termsOfUse.view.li48')}
                </li>
                <li>
                  {t('termsOfUse.view.li49')}
                </li>
                <li>{t('termsOfUse.view.li50')}</li>
                <li>{t('termsOfUse.view.li51')}</li>
              </ol>
            </BracketListItem>
          </li>
          <li>{t('termsOfUse.view.li52')}</li>
          <li>
            {t('termsOfUse.view.li53')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text9')}</Typography>
      <Typography gutterBottom>
        {t('termsOfUse.view.text10')}
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text11')}</Typography>
      <Typography gutterBottom>
        {t('termsOfUse.view.text12')}
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text55')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li54')}
          </li>
          <li>
            {t('termsOfUse.view.li55')}
          </li>
          <li>
            {t('termsOfUse.view.li56')}
          </li>
          <li>
            {t('termsOfUse.view.li57')}
            <BracketListItem>
              <ol>
                <li>{t('termsOfUse.view.li58')}</li>
                <li>
                  {t('termsOfUse.view.li59')}
                </li>
                <li>
                  {t('termsOfUse.view.li60')}
                </li>
                <li>
                  {t('termsOfUse.view.li61')}
                </li>
                <li>
                  {t('termsOfUse.view.li62')}
                </li>
                <li>
                  {t('termsOfUse.view.li63')}
                </li>
                <li>{t('termsOfUse.view.li64')}</li>
              </ol>
            </BracketListItem>
          </li>
          <li>
            {t('termsOfUse.view.li65')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text56')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li66')}
          </li>
          <li>
            {t('termsOfUse.view.li67')}
          </li>
          <li>
            {t('termsOfUse.view.li68')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text57')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li69')}
          </li>
          <li>
            {t('termsOfUse.view.li70')}
          </li>
          <li>
            {t('termsOfUse.view.li71')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text58')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li72')}
            <BracketListItem>
              <ol>
                <li>{t('termsOfUse.view.li73')}</li>
                <li>{t('termsOfUse.view.li74')}</li>
                <li>{t('termsOfUse.view.li75')}</li>
                <li>
                  {t('termsOfUse.view.li76')}
                </li>
                <li>{t('termsOfUse.view.li77')}</li>
              </ol>
            </BracketListItem>
          </li>
          <li>
            {t('termsOfUse.view.li78')}
          </li>
          <li>
            {t('termsOfUse.view.li79')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text59')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li80')}
            <BracketListItem>
              <ol>
                <li>{t('termsOfUse.view.li81')}</li>
                <li>{t('termsOfUse.view.li82')}</li>
                <li>
                  {t('termsOfUse.view.li83')}
                </li>
                <li>{t('termsOfUse.view.li84')}</li>
                <li>
                  {t('termsOfUse.view.li85')}
                </li>
                <li>
                  {t('termsOfUse.view.li86')}
                </li>
                <li>{t('termsOfUse.view.li87')}</li>
                <li>{t('termsOfUse.view.li88')}</li>
                <li>{t('termsOfUse.view.li89')}</li>
                <li>{t('termsOfUse.view.li90')}</li>
                <li>{t('termsOfUse.view.li91')}</li>
                <li>{t('termsOfUse.view.li92')}</li>
              </ol>
            </BracketListItem>
          </li>
          <li>
            {t('termsOfUse.view.li93')}
          </li>
          <li>
            {t('termsOfUse.view.li94')}
          </li>
          <li>
            {t('termsOfUse.view.li95')}
          </li>
          <li>
            {t('termsOfUse.view.li96')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text60')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li97')}
          </li>
          <li>
            {t('termsOfUse.view.li98')}
          </li>
          <li>
            {t('termsOfUse.view.li99')}
          </li>
          <li>
            {t('termsOfUse.view.li100')}
          </li>
          <li>
            {t('termsOfUse.view.li101')}
          </li>
          <li>
            {t('termsOfUse.view.li102')}
          </li>
          <li>
            {t('termsOfUse.view.li103')}
          </li>
          <li>
            {t('termsOfUse.view.li104')}
          </li>
          <li>
            {t('termsOfUse.view.li105')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text61')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li106')}
          </li>
          <li>
            {t('termsOfUse.view.li107')}
          </li>
          <li>
            {t('termsOfUse.view.li108')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text62')}</Typography>
      <Typography component="div">
        <ol>
          <li>{t('termsOfUse.view.li109')}</li>
          <li>{t('termsOfUse.view.li110')}</li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text63')}</Typography>
      <Typography component="div">
        <ol>
          <li>{t('termsOfUse.view.li111')}</li>
          <li>
            {t('termsOfUse.view.li112')}
          </li>
          <li>
            {t('termsOfUse.view.li113')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text64')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li114')}
          </li>
          <li>
            {t('termsOfUse.view.li115')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text23')}</Typography>
      <Typography gutterBottom>
        {t('termsOfUse.view.text24')}
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text25')}</Typography>
      <Typography gutterBottom>
        {t('termsOfUse.view.text26')}
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text27')}</Typography>
      <Typography gutterBottom>
        {t('termsOfUse.view.text28')}
      </Typography>
      <Typography variant="h3">{t('termsOfUse.view.text29')}</Typography>
      <Typography variant="h4">{t('termsOfUse.view.text30')}</Typography>
      <Typography gutterBottom>
        {t('termsOfUse.view.text31')}
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text65')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li116')}
          </li>
          <li>
            {t('termsOfUse.view.li117')}
          </li>
          <li>
            {t('termsOfUse.view.li118')}
          </li>
          <li>
            {t('termsOfUse.view.li119')}
          </li>
          <li>
            {t('termsOfUse.view.li120')}
            <BracketListItem>
              <ol>
                <li>
                  {t('termsOfUse.view.li121')}
                </li>
                <li>
                  {t('termsOfUse.view.li122')}
                </li>
              </ol>
            </BracketListItem>
          </li>
          <li>
            {t('termsOfUse.view.li123')}
          </li>
          <li>
            {t('termsOfUse.view.li124')}
          </li>
          <li>
            {t('termsOfUse.view.li125')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text66')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li126')}
          </li>
          <li>
            {t('termsOfUse.view.li127')}
          </li>
          <li>
            {t('termsOfUse.view.li128')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text67')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li129')}
          </li>
          <li>
            {t('termsOfUse.view.li130')}
          </li>
          <li>
            {t('termsOfUse.view.li131')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text68')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li132')}
          </li>
          <li>
            {t('termsOfUse.view.li133')}
          </li>
          <li>
            {t('termsOfUse.view.li134')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h3">{t('termsOfUse.view.text69')}</Typography>
      <Typography variant="h4">{t('termsOfUse.view.text70')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li135')}
          </li>
          <li>
            {t('termsOfUse.view.li136')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text71')}</Typography>
      <Typography component="div">
        <ol>
          <li>{t('termsOfUse.view.li137')}</li>
          <li>
            {t('termsOfUse.view.li138')}
          </li>
          <li>
            {t('termsOfUse.view.li139')}
          </li>
          <li>
            {t('termsOfUse.view.li140')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text39')}</Typography>
      <Typography gutterBottom>
        {t('termsOfUse.view.text40')}
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text72')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li141')}
            <BracketListItem>
              <ol>
                <li>
                  {t('termsOfUse.view.li142')}
                </li>
                <li>{t('termsOfUse.view.li143')}</li>
                <li>{t('termsOfUse.view.li144')}</li>
                <li>{t('termsOfUse.view.li145')}</li>
                <li>{t('termsOfUse.view.li146')}</li>
              </ol>
            </BracketListItem>
          </li>
          <li>
            {t('termsOfUse.view.li147')}
          </li>
          <li>
            {t('termsOfUse.view.li148')}
          </li>
          <li>{t('termsOfUse.view.li149')}</li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text73')}</Typography>
      <Typography gutterBottom>{t('termsOfUse.view.text74')}</Typography>
      <Typography variant="h4">{t('termsOfUse.view.text75')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li150')}
          </li>
          <li>{t('termsOfUse.view.li151')}</li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text76')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li152')}
          </li>
          <li>
            {t('termsOfUse.view.li153')}
          </li>
        </ol>
      </Typography>
      <Typography variant="h4">{t('termsOfUse.view.text77')}</Typography>
      <Typography component="div">
        <ol>
          <li>
            {t('termsOfUse.view.li154')}
          </li>
          <li>
            {t('termsOfUse.view.li155')}
          </li>
          <li>
            {t('termsOfUse.view.li156')}
          </li>
          <li>
            {t('termsOfUse.view.li157')}
          </li>
          <li>
            {t('termsOfUse.view.li158')}
          </li>
          <li>
            {t('termsOfUse.view.li159')}
          </li>
        </ol>
      </Typography>
    </DocumentLayout>
  )
}
